<template lang="pug">
div(v-if="hasImovel")
  div(v-if="hasEndereco")
    el-row(:span="24")
      el-col(:span="12")
          app-display(
            v-if="!isMA && !isAP"
            label="Tipo logradouro:",
            :content="exibirCampoComum(cadastroOriginal.imovel.endereco, 'tipoLogradouro')",
            :class = "compararImovelReurb.mudouEnderecoImovel.mudouTipoLogradouro ? 'text': '' "
          )
      el-col(:span="12")
        app-display(
          label="Endereço:",
          :content="exibirCampoComum(cadastroOriginal.imovel.endereco, 'loteamentoVila')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouEnderecoImovel.mudouLoteamantoVila ? 'text': '' "
        )

    el-row(:span="24")
      el-col(:span="12")
          app-display(
            label="Número:",
            :content="exibirCampoComum(cadastroOriginal.imovel.endereco, 'numero') || '-'",
            :class = "compararImovelReurb.mudouEnderecoImovel.mudouNumero ? 'text': '' "
          )
      el-col(:span="12")
        app-display(
          label="Complemento:",
          :content="exibirCampoComum(cadastroOriginal.imovel.endereco, 'complemento') || '-'",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouEnderecoImovel.mudouComplemento ? 'text': '' "
        )

    el-row(:span="24")
      el-col(:span="12")
          app-display(
            label="Bairro:",
            :content="exibirCampoComum(cadastroOriginal.imovel.endereco, 'bairro')",
            :class = "compararImovelReurb.mudouEnderecoImovel.mudouBairro ? 'text': '' "
          )
      el-col(:span="12")
        app-display(
          label="Área do imóvel (m²):",
          :content="exibirCampoComum(cadastroOriginal.imovel, 'area') || '-'",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouArea ? 'text': '' "
        )

    el-row(:span="24")
      el-col(:span="12" v-if="!isAP")
        app-display(
          :label="isMA ? 'Perímetro do lote (m²):' :'Área construída:'",
          :content="exibirCampoComum(cadastroOriginal.imovel, 'areaConstruida') || '-'",
          :class = "compararImovelReurb.mudouAreaConstruida ? 'text': '' "

        )
      el-col(:span="12")
        app-display(
          label="Quadra:",
          :content="exibirCampoComum(cadastroOriginal.imovel.endereco, 'quadra') || '-'",
          :class = "compararImovelReurb.mudouEnderecoImovel.mudouQuadra ? 'text': '' "
        )
    el-row(:span="24")
      el-col(:span="12")
        app-display(
          label="Lote:",
          :content="exibirCampoComum(cadastroOriginal.imovel.endereco, 'lote') || '-'",
          :class = "compararImovelReurb.mudouEnderecoImovel.mudouLote ? 'text': '' "
        )
      //- el-col(:span="12", v-if="isMA")
      //-   app-display(
      //-     label="É bem único:",
      //-     :content="cadastroOriginal.imovel.bemUnico ? 'Sim' : 'Não'",
      //-     :class = "cadastroOriginal.imovel.bemUnico ? 'text': '-' "
      //-   )
    el-row(:span="24" v-if="isAP")
      el-col(:span="12")
        app-display(
          label="Há poço:",
          :content="cadastroOriginal.imovel.possuiPoco ? 'Sim' : 'Não'",
          :class = "compararImovelReurb.mudouEnderecoImovel.mudouLote ? 'text': '' "
        )
      el-col(:span="12")
        app-display(
          label="Tipologia do poço:",
          :content="exibirValor(cadastroOriginal.imovel.tipologiaPoco, 'tipologiaPoco')",
          :class = "compararImovelReurb.mudouEnderecoImovel.mudouLote ? 'text': '' "
        )
  app-divider(label="Características gerais do imóvel")
  div(class="margin-top-10")
    el-row(:span="24")
      el-col(:span="12")
        app-display(
          label="Ocupação:",
          :content="exibirValor(cadastroOriginal.imovel.ocupacao , 'ocupacao')"
          :class = "compararImovelReurb.mudouOcupacao ? 'text': '' "
        )
      el-col(:span="12")
        app-display(
          label="Tipo:",
          :content="exibirValor(cadastroOriginal.imovel.estadoImovel , 'estadoImovel')"
          :marginBottom="true",
          :class = "compararImovelReurb.mudouEstadoImovel ? 'text': '' "
        )
    el-row(:span="24")
      el-col(:span="12")
        app-display(
          label="Dominialidade:",
          :content="exibirValor(cadastroOriginal.imovel.dominialidade , 'dominilidade')"
          :class = "compararImovelReurb.mudouDominilidade ? 'text': '' "
        )
      el-col(:span="12", v-if="cadastroOriginal.imovel.regimeUsos && cadastroOriginal.imovel.regimeUsos.length > 0")
        app-display-multiple(
          label="Regime de uso:",
          :content="exibirValores(cadastroOriginal.imovel.regimeUsos , 'regimeUsos')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouRegimeUso ? 'text': '' "
        )
      el-col(:span="12", v-if="cadastroOriginal.imovel.regimeUso")
        app-display(
          label="Regime de uso:",
          :content="exibirValor(cadastroOriginal.imovel.regimeUso , 'regimeUso')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouRegimeUso ? 'text': '' "
        )

  app-divider(v-if="hasTerreno" label="Características do terreno")
  div(v-if="hasTerreno", class="margin-top-10")
    el-row(:span="24")
      el-col(:span="12")
        app-display(
          label="Localização:",
          :content="exibirValor(cadastroOriginal.imovel.terreno.localizacao , 'localizacao')"
          :class = "compararImovelReurb.mudouTerreno.mudouLocalizacao ? 'text': '' "
        )
      el-col(:span="12", v-if="cadastroOriginal.imovel.terreno.delimitacao")
        app-display(
          label="Delimitação:",
          :content="exibirValor(cadastroOriginal.imovel.terreno.delimitacao , 'delimitacao')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouTerreno.mudouDelimitacao ? 'text': '' "
        )
      el-col(:span="12", v-if="cadastroOriginal.imovel.terreno.delimitacoes && cadastroOriginal.imovel.terreno.delimitacoes.length > 0")
        app-display-multiple(
          label="Delimitação:",
          :content="exibirValores(cadastroOriginal.imovel.terreno.delimitacoes , 'delimitacoes')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouTerreno.mudouDelimitacaos ? 'text': '' "
        )
    el-row(:span="24")
      el-col(:span="12", v-if="cadastroOriginal.imovel.terreno.situacao && !isMA")
        app-display(
          label="Situação:",
          :content="exibirValor(cadastroOriginal.imovel.terreno.situacao , 'situacao')"
          :class = "compararImovelReurb.mudouTerreno.mudouSituacao ? 'text': '' "
        )
      el-col(:span="12")
        app-display(
          label="Calçada externa:",
          :content="exibirValor(cadastroOriginal.imovel.terreno.calcadaExterna , 'calcadaExterna')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouTerreno.mudouCalcadaExterna ? 'text': '' "
        )
    el-row(:span="24")
      el-col(:span="12", v-if="cadastroOriginal.imovel.terreno.topografia")
        app-display(
          label="Topografia:",
          :content="exibirValor(cadastroOriginal.imovel.terreno.topografia , 'topografia')",
          :class = "compararImovelReurb.mudouTerreno.mudouTopografia ? 'text': '' "
        )
      el-col(:span="12")
        app-display(
          label="Quintal área livre:",
          :content="exibirValor(cadastroOriginal.imovel.terreno.quintalAreaLivre , 'quintalAreaLivre')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouTerreno.mudouQuintalAreaLivre ? 'text': '' "
        )

  app-divider(v-if="hasTerreno" label="Utilização do terreno")
  div(v-if="hasTerreno", class="margin-top-10")
    el-row(:span="24" v-if="!isMA")
      el-col(:span="12")
        app-display(
          label="Total de unidades:",
          :content="exibirCampoComum(cadastroOriginal.imovel.terreno, 'totalUnidades')",
          :class = "compararImovelReurb.mudouTerreno.mudouTotalUnidades ? 'text': '' "
        )
      el-col(:span="12", v-if="cadastroOriginal.imovel.terreno.possuiPiscina")
        app-display(
          label="Existência de piscina:",
          :content="exibirValor(cadastroOriginal.imovel.terreno.possuiPiscina , 'possuiPiscina')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouTerreno.mudouPossuiPiscina ? 'text': '' "
        )
    el-row(:span="24")
      el-col(:span="12")
        app-display(
          label="Existência de anexo:",
          :content="exibirValor(cadastroOriginal.imovel.terreno.possuiAnexo , 'possuiAnexo')"
          :class = "compararImovelReurb.mudouTerreno.mudouPossuiAnexo ? 'text': '' "
        )

  app-divider(v-if="hasUnidade" label="Descrição da unidade")
  div(v-if="hasUnidade", class="margin-top-10")
    el-row(:span="24")
      el-col(:span="12")
        app-display(
          label="Tipo:",
          :content="exibirValor(cadastroOriginal.imovel.unidade.tipoUnidade , 'tipoUnidade')"
          :class = "compararImovelReurb.mudouUnidade.mudouTipoUnidade ? 'text': '' "
        )
      el-col(:span="12", v-if="!isMA")
        app-display(
          label="Situação:",
          :content="exibirValor(cadastroOriginal.imovel.unidade.situacao , 'situacao')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouUnidade.mudouSituacao ? 'text': '' "
        )
    el-row(:span="24")
      el-col(:span="12", v-if="!isMA")
        app-display(
          label="Disposição:",
          :content="exibirValor(cadastroOriginal.imovel.unidade.disposicao , 'disposicao')"
          :class = "compararImovelReurb.mudouUnidade.mudouDisposicao ? 'text': '' "
        )
      el-col(:span="12")
        app-display(
          label="Implantação:",
          :content="exibirValor(cadastroOriginal.imovel.unidade.implantacao , 'implantacao')"
          :marginBottom="true",
          :class = "compararImovelReurb.mudouUnidade.mudouImplantacao ? 'text': '' "
        )
    el-row(:span="24")
      el-col(:span="12", v-if="!isMA")
        app-display(
          label="Tipologia:",
          :content="exibirValor(cadastroOriginal.imovel.unidade.tipologia , 'tipologia')"
          :class = "compararImovelReurb.mudouUnidade.mudouTipologia ? 'text': '' "
        )
      el-col(:span="12")
        app-display(
          label="Quantidade de pavimento:",
          :content="cadastroOriginal.imovel.unidade.qtdPavimento"
          :class = "compararImovelReurb.mudouUnidade.mudouQtdPavimento ? 'text': '' "
        )
    el-row(:span="24")
      el-col(:span="12")
        app-display(
          label="Padrão construtivo:",
          :content="exibirValor(cadastroOriginal.imovel.unidade.padraoConstrutivo , 'padraoConstrutivo')"
          :marginBottom="true",
          :class = "compararImovelReurb.mudouUnidade.mudouPadraoConstrutivo ? 'text': '' "
        )
    el-row(:span="24")
      el-col(:span="12")
        app-display(
          label="Conservação:",
          :content="exibirValor(cadastroOriginal.imovel.unidade.conservacao , 'conservacao')"
          :class = "compararImovelReurb.mudouUnidade.mudouConservacao ? 'text': '' "
        )

  app-divider(v-if="hasUnidade" label="Uso da unidade")
  div(v-if="hasUnidade", class="margin-top-10")
    el-row(:span="24")
      el-col(:span="12")
        app-display-multiple(
          label="Uso do solo:",
          :content="exibirValores(cadastroOriginal.imovel.unidade.usoSolos , 'usoSolos')"
          :class = "compararImovelReurb.mudouUnidade.mudouUsoSolos ? 'text': '' "
        )

  app-divider(v-if="hasConstrucao" label="Características externas da construção")
  div(v-if="hasConstrucao", class="margin-top-10")
    el-row(:span="24")
      el-col(:span="12")
        app-display-multiple(
          label="Cobertura:",
          :content="exibirValores(cadastroOriginal.imovel.construcao.coberturas , 'coberturas')"
          :class = "compararImovelReurb.mudouConstrucao.mudouCoberturas ? 'text': '' "
        )
      el-col(:span="12")
        app-display-multiple(
          label="Estrutura (parede):",
          :content="exibirValores(cadastroOriginal.imovel.construcao.estruturas , 'estruturas')"
          :marginBottom="true",
          :class = "compararImovelReurb.mudouConstrucao.mudouEstruturas ? 'text': '' "
        )
    el-row(:span="24", v-if="!isMA")
      el-col(:span="12")
        app-display-multiple(
          label="Paredes:",
          :content="exibirValores(cadastroOriginal.imovel.construcao.paredes , 'paredes')"
          :class = "compararImovelReurb.mudouConstrucao.mudouParedes ? 'text': '' "
        )
      el-col(:span="12")
        app-display-multiple(
          label="Revestimento:",
          :content="exibirValores(cadastroOriginal.imovel.construcao.revestimentos , 'revestimentos')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouConstrucao.mudouRevestimentos ? 'text': '' "
        )

  app-divider(v-if="hasConstrucao" label="Características internas da construção")
  div(v-if="hasConstrucao", class="margin-top-10")
    el-row(:span="24")
      el-col(:span="12")
        app-display(
          label="Fornecimento de energia:",
          :content="exibirValor(cadastroOriginal.imovel.construcao.fornecimentoEnergia , 'fornecimentoEnergia')",
          :class = "compararImovelReurb.mudouConstrucao.mudouFornecimentoEnergia ? 'text': '' "
        )
      el-col(:span="12", v-if="!isMA")
        app-display(
          label="Instalação elétrica:",
          :content="exibirValor(cadastroOriginal.imovel.construcao.instalacaoEletrica , 'instalacaoEletrica')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouConstrucao.mudouInstalacaoEletrica ? 'text': '' "
        )
    el-row(:span="24", v-if="!isMA")
      el-col(:span="12", v-if="cadastroOriginal.imovel.construcao.utilizacaoSanitario")
        app-display(
          label="Utilização do sanitário:",
          :content="exibirValor(cadastroOriginal.imovel.construcao.utilizacaoSanitario , 'utilizacaoSanitario')",
          :class = "compararImovelReurb.mudouConstrucao.mudouUtilizacaoSanitario ? 'text': '' "
        )
      el-col(:span="12", v-if="cadastroOriginal.imovel.construcao.utilizacoesSanitarios && cadastroOriginal.imovel.construcao.utilizacoesSanitarios.length > 0")
        app-display-multiple(
          label="Utilização do sanitário:",
          :content="exibirValores(cadastroOriginal.imovel.construcao.utilizacoesSanitarios , 'utilizacoesSanitarios')",
          :class = "compararImovelReurb.mudouConstrucao.mudouUtilizacaoSanitarios ? 'text': '' "
        )
      el-col(:span="12", v-if="cadastroOriginal.imovel.construcao.localizacaoSanitario")
        app-display(
          label="Localização do sanitário:",
          :content="exibirValor(cadastroOriginal.imovel.construcao.localizacaoSanitario , 'localizacaoSanitario')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouConstrucao.mudouLocalizacaoSanitario ? 'text': '' "
        )
      el-col(:span="12", v-if="cadastroOriginal.imovel.construcao.localizacoesSanitarios && cadastroOriginal.imovel.construcao.localizacoesSanitarios.length > 0")
        app-display-multiple(
          label="Localização do sanitário:",
          :content="exibirValores(cadastroOriginal.imovel.construcao.localizacoesSanitarios , 'localizacoesSanitarios')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouConstrucao.mudouLocalizacaoSanitarios ? 'text': '' "
        )
    el-row(:span="24", v-if="!isMA")
      el-col(:span="12")
        app-display-multiple(
          label="Pisos:",
          :content="exibirValores(cadastroOriginal.imovel.construcao.pisos , 'pisos')",
          :class = "compararImovelReurb.mudouConstrucao.mudouPisos ? 'text': '' "
        )
      el-col(:span="12")
        app-display-multiple(
          label="Forro:",
          :content="exibirValores(cadastroOriginal.imovel.construcao.forros , 'forros')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouConstrucao.mudouForros ? 'text': '' "
        )
    el-row(:span="24")
      el-col(:span="12")
        app-display(
          label="Número de compartimentos:",
          :content="exibirCampoComum(cadastroOriginal.imovel.construcao, 'numCompartimentos') || '-'",
          :class = "compararImovelReurb.mudouConstrucao.mudouNumCompartimentos ? 'text': '' "
        )
      el-col(:span="12")
        app-display(
          label="Número de quartos:",
          :content="exibirCampoComum(cadastroOriginal.imovel.construcao, 'numQuartos') || '-'",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouConstrucao.mudouNumQuartos ? 'text': '' "
        )
    el-row(:span="24", v-if="!isMA")
      el-col(:span="12")
      app-display(
        label="Número de sanitários:",
        :content="exibirCampoComum(cadastroOriginal.imovel.construcao, 'numSanitarios')",
        :class = "compararImovelReurb.mudouConstrucao.mudouNumSanitarios ? 'text': '' "
      )
  app-divider(v-if="hasConstrucao" label="Saneamento básico e meio ambiente")
  div(class="margin-top-10")
    el-row(:span="24")
      el-col(:span="12")
        app-display(
          label="Sistema do sanitário:",
          :content="exibirValor(cadastroOriginal.imovel.sistemaSanitario, 'sistemaSanitario')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouSistemaSanitario ? 'text': '' "
        )

      el-col(:span="12")
        app-display-multiple(
          label="Destinação do lixo:",
          :content="exibirValores(cadastroOriginal.imovel.destinacaoLixos, 'destinacaoLixos')",
          :class = "compararImovelReurb.mudouDestinacaoLixos ? 'text': '' "
        )
    el-row(:span="24")
      el-col(:span="12")
        app-display-multiple(
          label="Tipo de abastecimento de água:",
          :content="exibirValores(cadastroOriginal.imovel.abastecimentosAgua, 'abastecimentosAgua')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouAbastecimentoAgua ? 'text': '' "
        )

      el-col(:span="12", v-if="cadastroOriginal.imovel.arborizacao && !isMA")
        app-display(
          label="Quantidade de unidades de arborização:",
          :content="exibirValor(cadastroOriginal.imovel.arborizacao, 'arborizacao')",
          :marginBottom="true",
          :class = "compararImovelReurb.mudouArborizacao ? 'text': '' "
        )

  app-divider(label="Informações complementares")
  div(class="margin-top-10")
    el-row(:span="24" v-if="!isMA")
      el-col(:span="12")
        app-display(
          label="Aquisição do imóvel:",
          :content="exibirValor(cadastroOriginal.imovel.aquisicao, 'aquisicao')",
          :class = "compararImovelReurb.mudouAquisicao ? 'text': '' "
        )
      el-col(:span="12", v-if="cadastroOriginal.imovel.possuiAlvara")
        app-display(
          label="Possui alvará:",
          :content="exibirValor(cadastroOriginal.imovel.possuiAlvara, 'possuiAlvara')",
          :class = "compararImovelReurb.mudouPossuiAlvara ? 'text': '' "
        )
    el-row(:span="24")
      el-col(:span="12" v-if="isAP")
        app-display(
          :label="'Parecer técnico'",
          :content="cadastroOriginal.imovel.parecerTecnico || '-'",
          :class = "compararImovelReurb.mudouObservacoesGerais ? 'text': '' "
        )
      el-col(:span="12")
        app-display(
          :label="isAP ? 'Observações gerais:' : 'Informações necessárias (se houver):'",
          :content="cadastroOriginal.imovel.observacoesGerais || '-'",
          :class = "compararImovelReurb.mudouObservacoesGerais ? 'text': '' "
        )
  app-divider(label="Declaração de posse do imóvel",  v-if="isMA && hasDadosDeclaracaoPosseImovel")
  div(class="margin-top-10" v-if="isMA && hasDadosDeclaracaoPosseImovel")
    el-row(:span="24")
      el-col(:span="24")
        app-display(
          :label="'Você possui declaração de posse do imóvel?'",
          :content="hasDeclaracaoPosse ? 'Sim' : 'Não'",
          :class="'text'",
        )
      div(v-if="!hasDeclaracaoPosse")
        app-display(
          :content="this.messages.TEXTO_DECLARACAO_POSSE_TITULO",
          :class="'text'",
          style="text-align: center; font-weight: bold;"
          )
        app-display(
          :content="this.messages.TEXTO_DECLARACAO_POSSE_1",
          :class="'text'"
          )
        app-display(
          :content="this.messages.TEXTO_DECLARACAO_POSSE_2",
          :class="'text'"
          )
        app-display(
          :content="this.messages.TEXTO_DECLARACAO_POSSE_3",
          :class="'text'"
          )
        app-display(
          :content="this.tempoPosse",
          :class="'text'"
          )
  app-divider(label="Declaração de residência",  v-if="isMA && hasDadosDeclaracaoResidencia")
  div(class="margin-top-10" v-if="isMA && hasDadosDeclaracaoResidencia")
    el-row(:span="24")
      el-col(:span="24")
        app-display(
          :label="'Você possui declaração de residência?'",
          :content="cadastroOriginal.imovel.possuiDeclaracaoResidencia ? 'Sim' : 'Não'",
          :class="'text'",
        )
      div(v-if="!cadastroOriginal.imovel.possuiDeclaracaoResidencia")
        app-display(
          :content="this.messages.TITULO_DECLARACAO_RESIDENCIA",
          :class="'text'",
          style="text-align: center; font-weight: bold;"
        )
        app-display(
          :content="this.endereco",
          :class="'text'"
        )
        app-display(
          :content="this.messages.TEXTO_DECLARACAO_RESIDENCIA",
          :class="'text'"
        )
        app-display(
          :content="this.messages.TEXTO_DECLARACAO_RESIDENCIA_LEI",
          :class="'text'"
          style="margin-left: 60px;"
        )
        app-display(
          :content="this.messages.TEXTO_DECLARACAO_RESIDENCIA_ASSINATURA",
          :class="'text'"
        )

</template>

<script>
import AppDisplay from '@/components/AppDisplay'
import AppCollapse from '@/components/AppCollapse'
import AppDivider from '../AppDivider'
import enumImovelReurb from '@/utils/enumDadosImovelMobile'
import AppDisplayMultiple from '@/components/AppDisplayMultiple'
import messages from '../../constants/messages'

export default {

  components: {
    AppDisplay,
    AppCollapse,
    AppDivider,
    AppDisplayMultiple,
    messages
  },

  mixins: [
    enumImovelReurb
  ],

  data () {
    return {
      endereco: messages.TEXTO_DECLARACAO_RESIDENCIA_ENDERECO.replace('ENDERECO', this.getEnderecoCompleto()),
      messages: messages,
      tempoPosse: messages.TEMPO_POSSE.replace('POSSE', this.cadastroOriginal?.imovel?.tempoPosseImovel || '-')
    }
  },

  props: {
    cadastroOriginal: {
      type: Object,
      required: true
    },
    compararImovelReurb: {
      type: Object,
      required: false
    }
  },

  computed: {
    hasImovel () {
      return !!this.cadastroOriginal?.imovel
    },
    isMA () {
      return process.env.ESTADO === 'ma'
    },
    isAP () {
      return process.env.ESTADO === 'ap'
    },
    hasUnidade () {
      return !!this.cadastroOriginal?.imovel?.unidade
    },
    hasTerreno () {
      return !!this.cadastroOriginal?.imovel?.terreno
    },
    hasConstrucao () {
      return !!this.cadastroOriginal?.imovel?.construcao
    },
    hasEndereco () {
      return !!this.cadastroOriginal?.imovel?.endereco
    },
    hasDadosDeclaracaoPosseImovel () {
      return [true, false].includes(this.cadastroOriginal?.imovel?.possuiDeclaracaoPosse)
    },
    hasDadosDeclaracaoResidencia () {
      return [true, false].includes(this.cadastroOriginal?.imovel?.possuiDeclaracaoResidencia)
    },
    hasDeclaracaoPosse () {
      return this.cadastroOriginal?.imovel?.possuiDeclaracaoPosse && !this.cadastroOriginal?.imovel?.tempoPosseImovel
    }
  },

  methods: {
    exibirCampoComum (value, campo) {
      if (value) {
        if ((campo === 'area') || (campo === 'areaConstruida')) {
          let numero = value[campo]
          if (numero !== undefined && numero !== null) {
            let formatado = parseFloat(numero).toFixed(2).replace('.', ',')
            return formatado
          }
        } else {
          return value[campo] === 0 ? '0' : value[campo]
        }
      }

      return ' - '
    },
    exibirValor (value, campo) {
      if (value) {
        return enumImovelReurb[campo][value]
      }
      return ' - '
    },
    exibirValores (values, campo) {
      if (values && values.length > 0) {
        return values.map(value => enumImovelReurb[campo][value])
      }
      return '-'
    },
    getEnderecoCompleto () {
      return `${this.cadastroOriginal.imovel?.endereco?.loteamentoVila ? this.cadastroOriginal.imovel?.endereco?.loteamentoVila + ',' : ''}
      ${this.cadastroOriginal.imovel?.endereco?.numero ? 'número ' + this.cadastroOriginal.imovel?.endereco?.numero + ',' : ''}
      ${this.cadastroOriginal.imovel?.endereco?.complemento ? this.cadastroOriginal.imovel?.endereco?.complemento + ',' : ''}
      ${this.cadastroOriginal.imovel?.endereco?.lote ? 'lote ' + this.cadastroOriginal.imovel?.endereco?.lote + ',' : ''}
      ${this.cadastroOriginal.imovel?.endereco?.quadra ? 'quadra ' + this.cadastroOriginal.imovel?.endereco?.quadra + ',' : ''}
      ${this.cadastroOriginal.imovel?.endereco?.bairro ? this.cadastroOriginal.imovel?.endereco?.bairro : ''}`
    },
    formataTipologiaPoco (tipologia) {
      if (tipologia === 'ARTESIANO') {
        return 'Artesiano'
      }
      if (tipologia === 'AMAZONAS') {
        return 'Amazonas'
      }
      return '-'
    }
  }
}
</script>

<style lang="scss" scoped>
.margin-top-10 {
  padding: 10px;
}
.text .text{
  color: #ff0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/InformacoesImovelReurb.vue